// @flow
/* eslint-disable arrow-body-style */
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import Icon from 'components/_particles/icon/react/Icon';

type Props = {
  onClick: () => void,
  display: 'diagram' | 'list',
};

const ListSwitch = ({ onClick, display }: Props): React$MixedElement => {
  return (
    <div className="tax-calculator__list-switch">
      <button onClick={onClick}>
        <Icon
          icon={
            display === 'diagram'
              ? 'bw-bullet-list-solid'
              : 'bw-layout-grid-solid'
          }
        />
        <span className="tax-calculator__list-switch-text">
          {display === 'diagram'
            ? t('Als Liste darstellen')
            : t('Als Diagramm darstellen')}
        </span>
      </button>
    </div>
  );
};

export default ListSwitch;
